(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('CampaignSelectNewOwnerController', Controller);

    Controller.$inject = ['$scope', 'esbEmployeeService', '$timeout'];

    function Controller($scope, searchService, $timeout) {

        $timeout(function () {
            var searchField = document.querySelector('[autofocus]');
            if (searchField && searchField.focus && typeof searchField.focus === 'function') {
                searchField.focus();
            }
        }, 0);

        $scope.searchEmployees = function () {
            $scope.ctxSelectNewOwner.isOwnerNotAuthorized = false;

            var searchTerm = $scope.ctxSelectNewOwner.searchTerm;
            if (_.isUndefined(searchTerm) || searchTerm.length < 3) {
                $scope.availableOwners = [];
                
                return;
            }
            searchService
                .searchEmployees(searchTerm)
                .then(function (foundEmployees) {
                    $scope.availableOwners = _.filter(foundEmployees, function (foundEmployee) {
                        return !foundEmployee.DepartureDate && !_.some($scope.actualOwners, { ItemPersonID: foundEmployee.ItemPersonID });
                    });
                });
        }
    }
})();